import HttpClient from "@/common/boot/HttpClient"
import criarToast from '@/common/boot/ToastsHandler'

const listarTarefas = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.post('/ctrl-tarefas/visualizar', payload).then(response => {
      commit('LISTAR_DADOS', response.data.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarTarefasComFiltro = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  await HttpClient.post('/gestao-producao/tarefas/listar', payload).then(response => {
    commit('LISTAR_DADOS', response.data.data);
    commit('LISTAR_DADOS_ATIVOS', response.data.data);
    return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarTipoAgings = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/ctrl-tipos-agings', payload).then(response => {
    commit('LISTAR_DADOS_TIPOS_AGINGS', response.data.data);
    return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarTipoTarefas = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/ctrl-tipo-tarefas', payload).then(response => {
    commit('LISTAR_DADOS_TIPOS_TAREFAS', response.data.data);
    return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}


const excluirTarefas = async ({ dispatch },  payload) => { 
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
   
    dispatch('listarTarefas');
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-tarefas/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTarefa = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);
  
  return await HttpClient.post('/ctrl-tarefas', payload ).then(response => {
    dispatch('listarTarefas');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarTarefa = ({ commit, state }, payload) => {
  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_TAREFA_SELECIONADA', ...item);
    return true;
  }

  return false;
}

const atualizarTarefa = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);
   
  return await HttpClient.put(`/ctrl-tarefas/${payload.id}`, payload).then(response => {
    dispatch('listarTarefas');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

const restaurarTarefa = ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  return HttpClient.put(`/ctrl-tarefas/${payload.id}`, payload).then(response => {
    dispatch('listarTarefas');
    return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarTarefasDetalhadas = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/gestao-producao/tarefas-detalhadas', payload).then(response => {
      commit('LISTAR_DADOS_DETALHADOS', response.data.data);
      return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarOpcoesTratativas = async ({ commit }) => {
  commit('CARREGANDO', true);

  HttpClient.get('/gestao-producao/ctrl-tratativas-opcoes').then(response => {
    commit('INSERIR_TAREFA_OPCAO_TRATATIVA', response.data.data)
    return response;
  })
    .finally(() => {
      commit('CARREGANDO', false);
    })

  return true
}

const associarOpcoesTratativas = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  HttpClient.post(`/gestao-producao/tarefas/${payload.ctrl_tarefa_id}/associar-opcao-tratativa`, payload).then(response => {
      criarToast ({tipo: 'success', mensagem: 'Opções Tratativas associadas com sucesso!'})
      return response;
  })
  .finally( () => {
      commit('CARREGANDO', false);
  });
}

const buscaPodeInativar = async ({ commit }, payload) => {
  const response = await HttpClient.get(`/gestao-producao/tarefas/${payload.ctrl_tarefa_id}/pode-inativar`);
  commit('INSERIR_TAREFA_MOBILIDADES_E_OPCOES_TRATATIVAS', response.data.data);
  return response;
}

const atualizarTabIndex = async({ commit }, payload) => {
  commit('ATUALIZAR_TAB_INDEX', payload);
}

export {
  listarTarefas,
  listarTarefasComFiltro,
  listarTipoTarefas,
  listarTipoAgings,
  excluirTarefas,
  salvarTarefa,
  recuperarTarefa,
  atualizarTarefa,
  restaurarTarefa,
  listarTarefasDetalhadas,
  listarOpcoesTratativas,
  associarOpcoesTratativas,
  buscaPodeInativar,
  atualizarTabIndex
}